<div *ngIf="!isLoading; else loadingContainer">
  <div class="list-item" [ngClass]="{ 'bottom-border': !hideBottomBorder, 'high-light': highlightRow }">
    <div class="label" [ngClass]="{ 'high-light': highlightRow }">{{ label }}</div>
    <div class="text-value" [ngClass]="{ 'high-light': highlightRow }">
      {{ text }}
    </div>
  </div>
</div>

<ng-template #loadingContainer>
  <div class="list-item bottom-border">
    <div class="label"><lib-loading-shimmer [width]="'3.75rem'" /></div>
    <div class="text-value">
      <lib-loading-shimmer [width]="'7.4rem'" />
    </div>
  </div>
</ng-template>
